"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var filterClasses = exports.filterClasses = {
	AUTO: ["AUTO"],
	ESPOS: ["ESPOS"],
	GOODS_TRANSFER: ["GOODS_TRANSFER"],
	MANUFACTURER: ["MANUFACTURER"],
	MANUFACTURER_PRODUCT: ["MANUFACTURER_PRODUCT"],
	LIST: ["AUTO", "LIST"],
	GRID: ["AUTO", "GRID"],
	WEBSHOP: ["AUTO", "GRID", "LIST", "WEBSHOP"],
	FULL: ["AUTO", "GRID", "LIST", "FULL", "ESPOS", "WEBSHOP"],
	REORDER_PRODUCT: ["REORDER_PRODUCT"],
	INTRASTAT_PRODUCT: ["INTRASTAT_PRODUCT"]
};